import React from 'react';
import Loading from './Loading/Loading';

function ThemedSuspense() {
  return (
    <Loading />
  );
};

export default ThemedSuspense;
